var MDB = window.MDB || {};
MDB.Charts = MDB.Charts || {};
MDB.Charts.renderers = MDB.Charts.renderers || {};

MDB.Charts.renderers.tree = function (widget, chart, data, metadata) {
    if (!data || data.length === 0) {
        widget.find('.loading-box').hide();
        return;
    }

    //Widget expects every first column in a row to be the Parent and every second Column to be it's child
    function parseToJson(data) {

        var kendoConfig = metadata.KendoConfig;
        var nodeList = [];

        var node;
        data.forEach(function (item) {
            if (item[Object.keys(item)[2]] !== undefined) {
                node = {
                    "Parent": item[Object.keys(item)[0]],
                    "Name": item[Object.keys(item)[1]],
                    "NodeId": item[Object.keys(item)[2]]
                }
            } else {
                node = {
                    "Parent": item[Object.keys(item)[0]],
                    "Name": item[Object.keys(item)[1]]
                }
            }
            nodeList.push(node);
        });

        //Check if a root node was set by user. If not, attempt to find it.
        var root = "";
        if (kendoConfig.root === undefined) {
            root = getRootNode(nodeList);
        } else {
            root = kendoConfig.root;
        }

        var tree = {
            name: root,
            children: getChildren(root, nodeList)
        };

        return tree;
    }

    //Expects one record in the result set to have no parents
    function getRootNode(nodeList) {
        var items = [];
        var parents = [];

        nodeList.forEach(function (i) {
            items.push(i.Name);
            parents.push(i.Parent);
        });

        for (var i = 0; i < parents.length; i++) {
            if (!items.includes(parents[i])) {
                return parents[i];
            }
        }
    }

    function getChildren(nodeName, nodeList) {

        var children = [];
        nodeList.forEach(function (i) {
            if (i.Parent.toLowerCase() === nodeName.toLowerCase()) {
                var child = {
                    name: i.Name,
                    nodeId: i.NodeId,
                    children: getChildren(i.Name, nodeList)
                };
                children.push(child);
            }
        });
        return children;
    }

    function collapse(d) {
        if (d.children) {
            d._children = d.children;
            d._children.forEach(collapse);
            d.children = null;
        }
    }

    widget.find('.loading-box').hide();
    widget.find('.chart').append($('<div class="djs-tree">'));

    var margin = { top: 0, right: 120, bottom: 0, left: 120 },
        width = MDB.Charts.calculateKendoChartMaxHeight(widget) - margin.right - margin.left,
        height = MDB.Charts.calculateKendoChartMaxWidth(widget) - margin.top - margin.bottom;

    var i = 0,
        duration = 750,
        root;

    var tree = d3.layout.tree()
        .size([height, width]);

    var diagonal = d3.svg.diagonal()
        .projection(function (d) {
            return [d.y, d.x]; 
        });

    var svg = d3.select(".djs-tree").append("svg")
        .attr("width", width + margin.right + margin.left)
        .attr("height", height + margin.top + margin.bottom)
        .append("g")
        .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    root = parseToJson(data);
    root.x0 = height / 2;
    root.y0 = 0;

    if (root.children !== undefined) {
        root.children.forEach(collapse);
    }
    update(root);
    d3.select(self.frameElement).style("height", "800px");

    function update(source) {
        // Compute the new tree layout.
        var nodes = tree.nodes(root).reverse(),
            links = tree.links(nodes);

        // Normalize for fixed-depth.
        nodes.forEach(function (d) {
            d.y = d.depth * 180; 
        });

        // Update the nodes…
        var node = svg.selectAll("g.node")
            .data(nodes, function (d) {
                return d.id || (d.id = ++i); 
            });

        // Enter any new nodes at the parent's previous position.
        var nodeEnter = node.enter().append("g")
            .attr("class", "node")
            .attr("transform", function (d) {
                return "translate(" + source.y0 + "," + source.x0 + ")"; 
            })
            .on("click", click);

        nodeEnter.append("circle")
            .attr("r", 1e-6)
            .attr("id", function (d) {
                return d.nodeId; 
            } )
            .style("fill", function (d) {
                return d._children ? "lightsteelblue" : "#fff"; 
            });

        nodeEnter.append("text")
            .attr("x", function (d) {
                return d.children || d._children ? -10 : 10; 
            })
            .attr("dy", ".35em")
            .attr("text-anchor", function (d) {
                return d.children || d._children ? "end" : "start"; 
            })
            .text(function (d) {
                return d.name; 
            })
            .style("fill-opacity", 1e-6);

        // Transition nodes to their new position.
        var nodeUpdate = node.transition()
            .duration(duration)
            .attr("transform", function (d) {
                return "translate(" + d.y + "," + d.x + ")"; 
            });

        nodeUpdate.select("circle")
            .attr("r", 4.5)
            .style("fill", function (d) {
                return d._children ? "lightsteelblue" : "#fff"; 
            });

        nodeUpdate.select("text")
            .style("fill-opacity", 1);

        // Transition exiting nodes to the parent's new position.
        var nodeExit = node.exit().transition()
            .duration(duration)
            .attr("transform", function (d) {
                return "translate(" + source.y + "," + source.x + ")"; 
            })
            .remove();

        nodeExit.select("circle")
            .attr("r", 1e-6);

        nodeExit.select("text")
            .style("fill-opacity", 1e-6);

        // Update the links…
        var link = svg.selectAll("path.link")
            .data(links, function (d) {
                return d.target.id; 
            });

        // Enter any new links at the parent's previous position.
        link.enter().insert("path", "g")
            .attr("class", "link")
            .attr("d",
                function (d) {
                    var o = { x: source.x0, y: source.y0 };
                    return diagonal({ source: o, target: o });
                });

        // Transition links to their new position.
        link.transition()
            .duration(duration)
            .attr("d", diagonal);

        // Transition exiting nodes to the parent's new position.
        link.exit().transition()
            .duration(duration)
            .attr("d",
                function (d) {
                    var o = { x: source.x, y: source.y };
                    return diagonal({ source: o, target: o });
                })
            .remove();

        // Stash the old positions for transition.
        nodes.forEach(function (d) {
            d.x0 = d.x;
            d.y0 = d.y;
        });
    }

    // Toggle children on click.
    function click(d) {
        if (d.children) {
            d._children = d.children;
            d.children = null;
        } else {
            d.children = d._children;
            d._children = null;
        }
        update(d);
    }
}